import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { $axios } from "@bloglovin/vue-framework";

export const UserProfileElementMixin = {
  extends: DynamicElementMixin,
  methods: {
    getExampleEntity() {
      return {
        "username": "username",
        "bio": "I am a creator on inspiration.co",
        "avatarUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/avatar-default.png",
      };
    },
    async getRealEntity() {
      if (Object.keys(useGeneralStore().userData).length > 0) {
        return {
          bio: useGeneralStore().userBio,
          username: useGeneralStore().username,
          avatarUrl: useGeneralStore().userAvatar,
        };
      }
      return (await $axios.get(`/user/${useGeneralStore().userId}/profile`)).data;
    },
  },
};
